import i18n from '@/i18n'
import { SAML_CONNECTION_ENTITY_KEYS, SAML_DOMAIN_ENTITY_KEYS } from '@/utils/entity-keys'
import { uid } from '@/utils/uid'

export const SAML_TITLE = 'SAML'
export const SCIM_TITLE = 'SCIM'
export const SAML_ID = 1
export const SCIM_ID = 3

export const CONNECTIONS_PROTOCOLS = [SAML_ID, SCIM_ID]
export const CONNECTIONS = {
  [SCIM_ID]: SCIM_TITLE,
  [SAML_ID]: SAML_TITLE
}

export const isSaml = value => SAML_ID === value
export const isSCIM = value => SCIM_ID === value

export const SSO_NAME_MAX_LENGTH = 63

export const getProviders = () => [
  {
    label: 'Okta',
    value: 1
  },
  {
    label: 'Microsoft',
    value: 2
  },
  {
    label: 'Google',
    value: 3
  },
  {
    label: i18n.global.t('sso.other'),
    value: 0
  }
]

export const SAML_CONNECTION_STATUS_IDS = {
  INACTIVE_NO_CERTIFICATE: 0,
  INACTIVE_NO_DOMAINS: 1,
  ACTIVE: 2
}

export const isSamlConnectionActive = (connection = {}) =>
  connection[SAML_CONNECTION_ENTITY_KEYS.STATUS_ID] === SAML_CONNECTION_STATUS_IDS.ACTIVE

export const createDefaultDomainModel = () => {
  return {
    [SAML_DOMAIN_ENTITY_KEYS.ID]: uid(),
    [SAML_DOMAIN_ENTITY_KEYS.DOMAIN_NAME]: '',
    [SAML_DOMAIN_ENTITY_KEYS.IS_VALID]: true,
    [SAML_DOMAIN_ENTITY_KEYS.IS_UNIQUE]: true
  }
}

export const SAML_CONNECTION_DOMAIN_STATUS_IDS = {
  NOT_VERIFIED: 0,
  VERIFIED: 1
}
